import React from 'react';
import reviewIcon from '../../assets/icons/review.svg';

function ReviewCard({
  text, img, name, imgAlt, type,
}) {
  return (
    <div className="review__card">
      <div className="review__card-text-content">
        <img src={reviewIcon} alt="blockquote icon" />
        <blockquote>
          {text}
        </blockquote>
      </div>
      <figure className="review__card-user">
        <img className="review__card-user-image" src={img} alt={imgAlt || name || type || 'review user'} />
        <figcaption className="review__card-user-info">
          <p className="review__card-user-name">{name}</p>
          <p className="review__card-type">{type}</p>
        </figcaption>
      </figure>
    </div>
  );
}

export default ReviewCard;
